import React, { useEffect, useState, useContext } from 'react';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  NotificationList,
  Label,
  Button,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
} from 'quanta-ui';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
import {
  faDownload,
  faEnvelope,
  faEye,
  faInfoCircle,
  faPen,
  faShare,
  faSms,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalViewBreakup from '../../../../common/view-breakup/two-wheeler/view-breakup';
// import { ModalViewBreakupTW } from 'quanta-flows/modules/common/viewBreakUp';
import ModalViewBreakupTW from './view-breakup'
import ModalCovers from './modal-covers';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
import moment from 'moment';
import {
  SEND_RENEWAL_EMAIL_TW,
  SEND_RENEWAL_PDF_TW,
  SEND_RENEWAL_SMS_TW,
} from '../queries';
// import ModalSendEmail from '../../../../common/common-modals/modal-send-email';
// import { ModalSendEmailTwoWheeler } from 'quanta-flows/modules/quote/motor';
// import ModalSendSms from '../../../../common/common-modals/modal-send-sms';
// import { ModalSendSmsTwoWheeler } from 'quanta-flows/modules/quote/motor';
import { ModalSendEmail } from 'quanta-flows/modules/common/modals';
// import ModalSendSms from '../../../../common/common-modals/modal-send-sms';
import { ModalSendSmsTwoWheeler } from 'quanta-flows/modules/quote/motor';
import DownloadAndShare from './download-and-share';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';

export default function RenewProposalSummary({
  data: dataViewRenewPolicy,
  dataFinancerDropdownDetails,
  productName,
  productCode,
  lobCode,
  lobName,
  productType,
  renewalMode,
  ...props
}) {
  const mutateQuery = useMutationQuery();
  const [alerts, setAlerts] = useState([]);
  const [displayRenewalEmailModal, showRenewalEmailModal] =
    useState(false);
  const [displayRenewalSMSModal, showRenewalSMSModal] =
    useState(false);
  const [showDownloadAndShare, setShowDownloadAndShare] =
    useState(false);
  const { branding } = useContext(QuantaConfigContext);

  const MINOR_THRESHOLD_AGE = 18;
  let vehicleIDV=dataViewRenewPolicy?.viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV;
  let electricalLimit =vehicleIDV*25/100;
  const NumberlimitRS =electricalLimit;
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const validate = (values) => {
    let errors = {};
    // if (!values?.premiumData?.tenure) {
    //   errors.premiumData = { tenure: '* Required' };
    // }
    errors.addOnCovers = {};
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach(
      (riskCover) => {
        riskCover?.covers?.forEach((cover) => {
          if (values['addOnCovers'][`${cover?.name}`].selected) {
             if (cover?.index === 'N410106G0088'){
                
                if(!values['addOnCovers']['Consumable Cover'].selected){
               
                  //setAddOnCoverErrors('Depreciation Cover is Selected, Consumable Cover is Mandatory ');
                 errors.addOnCoversError = 'Depreciation Cover is Selected, Consumable Cover is Mandatory ';
                 sessionStorage?.setItem(
                  'addOnCoversError',
                  'Depreciation Cover is Selected, Consumable Cover is Mandatory ',
                );
                }
                
             }
             if(values['addOnCovers']['Owner Driver'].selected&&viewRenewMotorPolicy?.proposerDetails?.customerType!=='Individual'){
              errors[`addOnCovers`][`Owner Driver`]='* Owner Driver cover cannot be opted for Organisation Customer'
              errors.addOnCoversError ='* Owner Driver cover cannot be opted for Organisation Customer'

             }
            cover?.attributes
              ?.filter((attribute) => attribute?.showOnScreen)
              ?.forEach((attribute) => {
                if (
                  !values[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                  ][`${attribute?.name}`]
                ) {
                  if (
                    errors[`addOnCovers`][`${cover?.name}`] ===
                    undefined
                  ) {
                    errors[`addOnCovers`][`${cover?.name}`] = {
                      attributes: {},
                    };
                  }
                  if (
                    !(
                      values[`addOnCovers`][`${cover?.name}`][
                        `attributes`
                      ][
                        `${
                          cover?.attributes
                            ?.filter(
                              (attribute) => attribute?.showOnScreen,
                            )
                            ?.find(
                              (attribute) =>
                                attribute?.displayName?.toLowerCase() ===
                                'nominee dob',
                            )?.name
                        }`
                      ] &&
                      moment(new Date(), 'DD/MM/YYYY').diff(
                        moment(
                          values[`addOnCovers`][`${cover?.name}`][
                            `attributes`
                          ][
                            `${
                              cover?.attributes
                                ?.filter(
                                  (attribute) =>
                                    attribute?.showOnScreen,
                                )
                                ?.find(
                                  (attribute) =>
                                    attribute?.displayName?.toLowerCase() ===
                                    'nominee dob',
                                )?.name
                            }`
                          ],
                          'DD/MM/YYYY',
                        ),
                        'years',
                      ) >= MINOR_THRESHOLD_AGE &&
                      (attribute?.displayName?.toLowerCase() ===
                        'name of appointee' ||
                        attribute?.displayName?.toLowerCase() ===
                          'relationship of appointee')
                    )
                  ) {
                    errors[`addOnCovers`][`${cover?.name}`][
                      `attributes`
                    ][`${attribute?.name}`] = '* Required';
                  }
                }

                if (
                  attribute?.fieldDataType === 'amount' &&
                  parseFloat(
                    values[`addOnCovers`][`${cover?.name}`][
                      `attributes`
                    ][`${attribute?.name}`],
                  ) <= 0
                ) {
                  if (
                    errors[`addOnCovers`][`${cover?.name}`] ===
                    undefined
                  ) {
                    errors[`addOnCovers`][`${cover?.name}`] = {
                      attributes: {},
                    };
                  }
                  errors[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                  ][`${attribute?.name}`] =
                    '* Amount should be greater than 0';
                }
                if (
                  attribute?.fieldType == 'checkbox' &&
                    values[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                    ][`${attribute?.name}`]!==true
                  
                ) {
                  if (
                    errors[`addOnCovers`][`${cover?.name}`] ===
                    undefined
                  ) {
                    errors[`addOnCovers`][`${cover?.name}`] = {
                      attributes: {},
                    };
                  }
                  errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                    `${attribute?.name}`
                  ] = '* Required';
                }

                if (
                  attribute?.fieldDataType === 'date' &&
                  moment(
                    values[`addOnCovers`][`${cover?.name}`][
                      `attributes`
                    ][`${attribute?.name}`],
                    'DD/MM/YYYY',
                  ).isAfter(moment(new Date(), 'DD/MM/YYYY'))
                ) {
                  if (
                    errors[`addOnCovers`][`${cover?.name}`] ===
                    undefined
                  ) {
                    errors[`addOnCovers`][`${cover?.name}`] = {
                      attributes: {},
                    };
                  }
                  errors[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                  ][`${attribute?.name}`] =
                    '* Cannot accept future date';
                }
              });
            if (
              errors[`addOnCovers`][`${cover?.name}`] &&
              errors[`addOnCovers`][`${cover?.name}`][`attributes`] &&
              Object.keys(
                errors[`addOnCovers`][`${cover?.name}`][`attributes`],
              )?.length === 0
            ) {
              delete errors[`addOnCovers`][`${cover?.name}`];
            }
          }
        });
      },
    );
    return errors;
  };

  if (dataViewRenewPolicy) {
    var viewRenewMotorPolicy =
      dataViewRenewPolicy?.viewRenewMotorPolicy;
  }
 const getRenewalInput = () => {
    let riskInput = [];
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      Object.keys(viewRenewMotorPolicy?.coverData?.addOnCovers)
        ?.filter(
          (coverName) =>
            viewRenewMotorPolicy?.coverData?.addOnCovers[
              `${coverName}`
            ]?.riskName
              ?.toString()
              ?.toLowerCase() ===
              r?.riskType?.toString()?.toLowerCase() &&
            !r?.covers?.find(
              (cov) =>
                cov?.name?.toString()?.toLowerCase() ===
                coverName?.toString()?.toLowerCase(),
            ),
        )
        ?.forEach((coverName) => {
          covers?.push({
            name: coverName,
            index: viewRenewMotorPolicy?.coverData?.addOnCovers[
              `${coverName}`
            ]?.index
              ? `${
                  viewRenewMotorPolicy?.coverData?.addOnCovers[
                    `${coverName}`
                  ]?.index
                }`
              : '',
            attributes: [],
          });
        });
      r.covers
        .filter(
          (c) =>
            viewRenewMotorPolicy?.coverData[`addOnCovers`][c?.name]
              ?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    viewRenewMotorPolicy?.coverData[`addOnCovers`][
                      `${c?.name}`
                    ][`attributes`][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        renewalMode,
        productCode,
        productType,
        customerType:
          viewRenewMotorPolicy?.proposerDetails?.customerType,
        gender: viewRenewMotorPolicy?.proposerDetails?.gender,
        businessType: viewRenewMotorPolicy?.businessType,
        intermediary: {
          intermediaryCode: viewRenewMotorPolicy?.intermediaryDetails
            ?.code
            ? `${viewRenewMotorPolicy?.intermediaryDetails?.code}`
            : '',
          locationCode: viewRenewMotorPolicy?.intermediaryDetails
            ?.location
            ? `${viewRenewMotorPolicy?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: viewRenewMotorPolicy?.intermediaryDetails
            ?.fieldUserCode
            ? `${viewRenewMotorPolicy?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        tenure:
          viewRenewMotorPolicy?.premiumData?.tenure ||
          viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
            ? `${
                viewRenewMotorPolicy?.premiumData?.tenure ||
                viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
              }`
            : '',
        rto: {
          rtoAuthCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.make?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.model?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.variant?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
          registrationNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
          manufactureYear: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.fuelType
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
          vehicleSegment: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.vehicleSegment
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.vehicleSegment}`
            : '',
          preInspectionNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.preInspectionNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.preInspectionNumber}`
            : '',
        },
        sideCarValue:
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.sideCarValue !== null &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.sideCarValue !== undefined &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.sideCarValue !== ''
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.sideCarValue}`
            : '',
        firstYearIDV:
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV !== undefined &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV !== null &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV !== ''
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : '',
        irf1:
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.irfAdjustmentPercent !==
            undefined &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.irfAdjustmentPercent !== null &&
          viewRenewMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.irfAdjustmentPercent !== ''
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
            : '',
        prevInsurance: {
          coverType: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
        },
        prevClaims: {
          totalClaimCount: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.totalClaimCount
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
            : '',
          claimsInYear1: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear1
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
            : '',
          claimsInYear2: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear2
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
            : '',
          claimsInYear3: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear3
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
            : '',
          prevNCBSlab: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.previousYearNCBSlab
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
            : '',
          totalClaimAmount: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.totalClaimAmount
            ? parseFloat(
                viewRenewMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.totalClaimAmount,
              )
            : null,
          claimFreeYear: viewRenewMotorPolicy?.premiumData
            ?.claimFreeYear
            ? `${viewRenewMotorPolicy?.premiumData?.claimFreeYear}`
            : '',
        },
        financerDetails: {
          financerName:
            getDomainData(
              dataFinancerDropdownDetails?.PRD_IsYourVehicle,
              viewRenewMotorPolicy?.additionalTabDetails
                ?.financeDetails?.vehicleOwned,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'financed'
              ? viewRenewMotorPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerName
              : '',
          financerAddress: viewRenewMotorPolicy?.additionalTabDetails
            ?.financeDetails?.financerDetails?.financerAddress
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAddress}`
            : '',
          financerAgreementType: viewRenewMotorPolicy
            ?.additionalTabDetails?.financeDetails?.financerDetails
            ?.financerAgreementType
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAgreementType}`
            : '',
          loanAccountNumber: viewRenewMotorPolicy
            ?.additionalTabDetails?.financeDetails?.financerDetails
            ?.loanAccountNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.loanAccountNumber}`
            : '',
          fileNumber: viewRenewMotorPolicy?.additionalTabDetails
            ?.financeDetails?.financerDetails?.fileNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.fileNumber}`
            : '',
        },
        riskCovers: riskInput,
        creditScore: {
          discountOpted:
            viewRenewMotorPolicy?.quoteData?.getAdditionalCreditScore
              ?.toString()
              ?.toLowerCase() === 'yes'
              ? true
              : false,
          idProofType: viewRenewMotorPolicy?.quoteData?.idProofType
            ? `${viewRenewMotorPolicy?.quoteData?.idProofType}`
            : '',
          idProofNumber: viewRenewMotorPolicy?.quoteData
            ?.idProofNumber
            ? `${viewRenewMotorPolicy?.quoteData?.idProofNumber}`
            : '',
          creditScore:
            viewRenewMotorPolicy?.premiumData?.creditScore !== null &&
            viewRenewMotorPolicy?.premiumData?.creditScore !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.creditScore !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.creditScore,
                )
              : null,
        },
        proposerPincode:
          viewRenewMotorPolicy?.proposerDetails?.commPincode ||
          viewRenewMotorPolicy?.proposerDetails?.permPincode
            ? viewRenewMotorPolicy?.proposerDetails?.commPincode ||
              viewRenewMotorPolicy?.proposerDetails?.permPincode
            : '',
        voluntaryDeductibleAmt:
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== null &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== undefined &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== ''
            ? parseFloat(
                viewRenewMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount,
              )
            : null,
        customer: {
          id: viewRenewMotorPolicy?.proposerDetails?.id
            ? `${viewRenewMotorPolicy?.proposerDetails?.id}`
            : '',
          customerType: viewRenewMotorPolicy?.proposerDetails
            ?.customerType
            ? `${viewRenewMotorPolicy?.proposerDetails?.customerType}`
            : '',
          isThinCustomer: false,
          title: viewRenewMotorPolicy?.proposerDetails?.title
            ? `${viewRenewMotorPolicy?.proposerDetails?.title}`
            : '',
          gender: viewRenewMotorPolicy?.proposerDetails?.gender
            ? `${viewRenewMotorPolicy?.proposerDetails?.gender}`
            : '',
          firstName: viewRenewMotorPolicy?.proposerDetails?.firstName
            ? `${viewRenewMotorPolicy?.proposerDetails?.firstName}`
            : '',
          middleName: viewRenewMotorPolicy?.proposerDetails
            ?.middleName
            ? `${viewRenewMotorPolicy?.proposerDetails?.middleName}`
            : '',
          lastName: viewRenewMotorPolicy?.proposerDetails?.lastName
            ? `${viewRenewMotorPolicy?.proposerDetails?.lastName}`
            : '',
          fullName: viewRenewMotorPolicy?.proposerDetails?.fullName
            ? `${viewRenewMotorPolicy?.proposerDetails?.fullName}`
            : '',
          proposerDOB: viewRenewMotorPolicy?.proposerDetails
            ?.proposerDOB
            ? `${viewRenewMotorPolicy?.proposerDetails?.proposerDOB}`
            : '',
          maritalStatus: viewRenewMotorPolicy?.proposerDetails
            ?.maritalStatus
            ? `${viewRenewMotorPolicy?.proposerDetails?.maritalStatus}`
            : '',
          occupation: viewRenewMotorPolicy?.proposerDetails
            ?.occupation
            ? `${viewRenewMotorPolicy?.proposerDetails?.occupation}`
            : '',
          nationality: viewRenewMotorPolicy?.proposerDetails
            ?.nationality
            ? `${viewRenewMotorPolicy?.proposerDetails?.nationality}`
            : '',
          idProofType: viewRenewMotorPolicy?.proposerDetails
            ?.idProofType
            ? `${viewRenewMotorPolicy?.proposerDetails?.idProofType}`
            : '',
          idProofNumber: viewRenewMotorPolicy?.proposerDetails
            ?.idProofNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.idProofNumber}`
            : '',
          panNumber: viewRenewMotorPolicy?.proposerDetails?.panNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.panNumber}`
            : '',
          orgName: viewRenewMotorPolicy?.proposerDetails?.orgName
            ? `${viewRenewMotorPolicy?.proposerDetails?.orgName}`
            : '',
          orgType: viewRenewMotorPolicy?.proposerDetails?.orgType
            ? `${viewRenewMotorPolicy?.proposerDetails?.orgType}`
            : '',
          contactName: viewRenewMotorPolicy?.proposerDetails
            ?.contactName
            ? `${viewRenewMotorPolicy?.proposerDetails?.contactName}`
            : '',
          regNumber: viewRenewMotorPolicy?.proposerDetails?.regNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.regNumber}`
            : '',
          tanNumber: viewRenewMotorPolicy?.proposerDetails?.tanNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.tanNumber}`
            : '',
          gstNumber: viewRenewMotorPolicy?.proposerDetails?.gstNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.gstNumber}`
            : '',
          permAddressLine1: viewRenewMotorPolicy?.proposerDetails
            ?.permAddressLine1
            ? `${viewRenewMotorPolicy?.proposerDetails?.permAddressLine1}`
            : '',
          permAddressLine2: viewRenewMotorPolicy?.proposerDetails
            ?.permAddressLine2
            ? `${viewRenewMotorPolicy?.proposerDetails?.permAddressLine2}`
            : '',
          permAddressLine3: viewRenewMotorPolicy?.proposerDetails
            ?.permAddressLine3
            ? `${viewRenewMotorPolicy?.proposerDetails?.permAddressLine3}`
            : '',
          permLandmark: viewRenewMotorPolicy?.proposerDetails
            ?.permLandmark
            ? `${viewRenewMotorPolicy?.proposerDetails?.permLandmark}`
            : '',
          permPincode: viewRenewMotorPolicy?.proposerDetails
            ?.permPincode
            ? `${viewRenewMotorPolicy?.proposerDetails?.permPincode}`
            : '',
          permCityTownVillage: viewRenewMotorPolicy?.proposerDetails
            ?.permCityTownVillage
            ? `${viewRenewMotorPolicy?.proposerDetails?.permCityTownVillage}`
            : '',
          permDistrict: viewRenewMotorPolicy?.proposerDetails
            ?.permDistrict
            ? `${viewRenewMotorPolicy?.proposerDetails?.permDistrict}`
            : '',
          permState: viewRenewMotorPolicy?.proposerDetails?.permState
            ? `${viewRenewMotorPolicy?.proposerDetails?.permState}`
            : '',
          permCommAddressYN: viewRenewMotorPolicy?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1: viewRenewMotorPolicy?.proposerDetails
            ?.commAddressLine1
            ? `${viewRenewMotorPolicy?.proposerDetails?.commAddressLine1}`
            : '',
          commAddressLine2: viewRenewMotorPolicy?.proposerDetails
            ?.commAddressLine2
            ? `${viewRenewMotorPolicy?.proposerDetails?.commAddressLine2}`
            : '',
          commAddressLine3: viewRenewMotorPolicy?.proposerDetails
            ?.commAddressLine3
            ? `${viewRenewMotorPolicy?.proposerDetails?.commAddressLine3}`
            : '',
          commLandmark: viewRenewMotorPolicy?.proposerDetails
            ?.commLandmark
            ? `${viewRenewMotorPolicy?.proposerDetails?.commLandmark}`
            : '',
          commPincode: viewRenewMotorPolicy?.proposerDetails
            ?.commPincode
            ? `${viewRenewMotorPolicy?.proposerDetails?.commPincode}`
            : '',
          commCityTownVillage: viewRenewMotorPolicy?.proposerDetails
            ?.commCityTownVillage
            ? `${viewRenewMotorPolicy?.proposerDetails?.commCityTownVillage}`
            : '',
          commDistrict: viewRenewMotorPolicy?.proposerDetails
            ?.commDistrict
            ? `${viewRenewMotorPolicy?.proposerDetails?.commDistrict}`
            : '',
          commState: viewRenewMotorPolicy?.proposerDetails?.commState
            ? `${viewRenewMotorPolicy?.proposerDetails?.commState}`
            : '',
          phoneNo: viewRenewMotorPolicy?.proposerDetails?.phoneNo
            ? `${viewRenewMotorPolicy?.proposerDetails?.phoneNo}`
            : '',
          mobileNo: viewRenewMotorPolicy?.proposerDetails?.mobileNo
            ? `${viewRenewMotorPolicy?.proposerDetails?.mobileNo}`
            : '',
          emailID: viewRenewMotorPolicy?.proposerDetails?.emailID
            ? `${viewRenewMotorPolicy?.proposerDetails?.emailID}`
            : '',
          faxNo: viewRenewMotorPolicy?.proposerDetails?.faxNo
            ? `${viewRenewMotorPolicy?.proposerDetails?.faxNo}`
            : '',
          altPhoneNo: viewRenewMotorPolicy?.proposerDetails
            ?.altPhoneNo
            ? `${viewRenewMotorPolicy?.proposerDetails?.altPhoneNo}`
            : '',
          altMobileNo: viewRenewMotorPolicy?.proposerDetails
            ?.altMobileNo
            ? `${viewRenewMotorPolicy?.proposerDetails?.altMobileNo}`
            : '',
          ifscCode: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.ifscCode
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.ifscCode}`
            : '',
          bankName: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.bankName
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.bankName}`
            : '',
          branchName: viewRenewMotorPolicy?.proposerDetails
            ?.branchName
            ? `${viewRenewMotorPolicy?.proposerDetails?.branchName}`
            : '',
          bankAcno: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.bankAcno
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.bankAcno}`
            : '',
          accountHolderName: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.accountHolderName
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.accountHolderName}`
            : '',
          micrCode: viewRenewMotorPolicy?.proposerDetailsMeta
            ?.micrCode
            ? `${viewRenewMotorPolicy?.proposerDetailsMeta?.micrCode}`
            : '',
          employeeNumber: viewRenewMotorPolicy?.proposerDetails
            ?.employeeNumber
            ? `${viewRenewMotorPolicy?.proposerDetails?.employeeNumber}`
            : '',
        },
        quoteNumber: viewRenewMotorPolicy?.quoteNumber
          ? `${viewRenewMotorPolicy?.quoteNumber}`
          : '',
        proposalNumber: viewRenewMotorPolicy?.proposalNumber
          ? `${viewRenewMotorPolicy?.proposalNumber}`
          : '',
        policyNumber: viewRenewMotorPolicy?.policyNumber
          ? `${viewRenewMotorPolicy?.policyNumber}`
          : '',
        leadGenerator: viewRenewMotorPolicy
          ?.reviewAndConfirmTabDetails?.leadGenerator
          ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
          : '',
        proposalPaymentType: viewRenewMotorPolicy
          ?.reviewAndConfirmTabDetails?.proposalPaymentType
          ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.proposalPaymentType}`
          : '',
        premiumBreakup: {
          idvYear1:
            viewRenewMotorPolicy?.premiumData?.idv1 !== null &&
            viewRenewMotorPolicy?.premiumData?.idv1 !== undefined &&
            viewRenewMotorPolicy?.premiumData?.idv1 !== ''
              ? parseFloat(viewRenewMotorPolicy?.premiumData?.idv1)
              : null,
          idvYear2:
            viewRenewMotorPolicy?.premiumData?.idv2 !== null &&
            viewRenewMotorPolicy?.premiumData?.idv2 !== undefined &&
            viewRenewMotorPolicy?.premiumData?.idv2 !== ''
              ? parseFloat(viewRenewMotorPolicy?.premiumData?.idv2)
              : null,
          idvYear3:
            viewRenewMotorPolicy?.premiumData?.idv3 !== null &&
            viewRenewMotorPolicy?.premiumData?.idv3 !== undefined &&
            viewRenewMotorPolicy?.premiumData?.idv3 !== ''
              ? parseFloat(viewRenewMotorPolicy?.premiumData?.idv3)
              : null,
          netODPremium:
            viewRenewMotorPolicy?.premiumData?.netODPremium !==
              null &&
            viewRenewMotorPolicy?.premiumData?.netODPremium !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.netODPremium !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.netODPremium,
                )
              : null,
          netTPPremium:
            viewRenewMotorPolicy?.premiumData?.netTPPremium !==
              null &&
            viewRenewMotorPolicy?.premiumData?.netTPPremium !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.netTPPremium !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.netTPPremium,
                )
              : null,
          loadingDiscount:
            viewRenewMotorPolicy?.premiumData?.loadingDiscount !==
              null &&
            viewRenewMotorPolicy?.premiumData?.loadingDiscount !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.loadingDiscount !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.loadingDiscount,
                )
              : null,
          netPremium:
            viewRenewMotorPolicy?.premiumData?.netPremium !== null &&
            viewRenewMotorPolicy?.premiumData?.netPremium !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.netPremium !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.netPremium,
                )
              : null,
          gst:
            viewRenewMotorPolicy?.premiumData?.gst !== null &&
            viewRenewMotorPolicy?.premiumData?.gst !== undefined &&
            viewRenewMotorPolicy?.premiumData?.gst !== ''
              ? parseFloat(viewRenewMotorPolicy?.premiumData?.gst)
              : null,
          stampDuty:
            viewRenewMotorPolicy?.premiumData?.stampDuty !== null &&
            viewRenewMotorPolicy?.premiumData?.stampDuty !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.stampDuty !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.stampDuty,
                )
              : null,
          totalPremium:
            viewRenewMotorPolicy?.premiumData?.totalPremium !==
              null &&
            viewRenewMotorPolicy?.premiumData?.totalPremium !==
              undefined &&
            viewRenewMotorPolicy?.premiumData?.totalPremium !== ''
              ? parseFloat(
                  viewRenewMotorPolicy?.premiumData?.totalPremium,
                )
              : null,
          loading:
            viewRenewMotorPolicy?.premiumData?.loading &&
            viewRenewMotorPolicy?.premiumData?.loading?.length > 0
              ? viewRenewMotorPolicy?.premiumData?.loading
              : [],
          discount:
            viewRenewMotorPolicy?.premiumData?.discount &&
            viewRenewMotorPolicy?.premiumData?.discount?.length > 0
              ? viewRenewMotorPolicy?.premiumData?.discount
              : [],
        },
        startDate: viewRenewMotorPolicy?.policy?.startDate,
        endDate: viewRenewMotorPolicy?.policy?.endDate,
      },
    };
  };

  const SummaryForm = () => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [showCovers, setShowCovers] = useState(false);
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    const [downloadingPDF, setDownloadingPDF] = useState(false);
    const [valuesBeforeEdit, setValuesBeforeEdit] = useState(null);

    const repeatForMobile = 2,
      repeatForDesktop = 1,
      repeatForIPad = 4;

    let repeat = useResponsiveParams({
      for_mobile: repeatForMobile,
      for_desktop: repeatForDesktop,
      for_iPad: repeatForIPad,
    });

    let renewProposalSummaryDataDesktopView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                Policy Number
              </Text>
            ),
            colSpan: 1,
            text: viewRenewMotorPolicy?.policyNumber ? (
              <Text type="normal">
                {viewRenewMotorPolicy?.issuedPolicyData?.policyNo
                ?viewRenewMotorPolicy?.issuedPolicyData?.policyNo
                :viewRenewMotorPolicy?.policyNumber}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Proposal Number
              </Text>
            ),
            colSpan: 1,
            text: viewRenewMotorPolicy?.proposalNumber ? (
              <Text type="normal">
                {viewRenewMotorPolicy?.proposalNumber}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Proposal Status
              </Text>
            ),
            colSpan: 1,
            text: viewRenewMotorPolicy?.proposalStatus ? (
              <Text type="normal">
                {viewRenewMotorPolicy?.proposalStatus}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Product Variant
              </Text>
            ),
            colSpan: 1,
            text: viewRenewMotorPolicy?.productType ? (
              <Text type="normal">
                {viewRenewMotorPolicy?.productType?.toLowerCase()?.search('comprehensive') !== -1
                ?'GCV-Comprehensive':'GCV-Liability only'}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex items-end justify-between mt-2">
                <span>
                  <Button
                    type="button"
                    size="small"
                    onClick={async (_) => {
                      setShowCovers(true);
                      setValuesBeforeEdit(values);
                    }}
                    className="w-40"
                    flat={true}
                    disabled={
                      !viewRenewMotorPolicy?.isProposalReadyForRenewal ||
                      viewRenewMotorPolicy?.isProposalRenewing
                    }
                  >
                    {viewRenewMotorPolicy?.isProposalRenewed
                      ? 'View Covers'
                      : `View & Edit Covers`}
                  </Button>
                </span>
              </div>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Tenure
              </Text>
            ),
            colSpan: 1,
            text:
              viewRenewMotorPolicy?.quoteData?.tenure ||
              viewRenewMotorPolicy?.quoteData?.premiumData?.tenure ? (
                <Text>
                  {`${
                    viewRenewMotorPolicy?.quoteData?.premiumData
                      ?.tenure ||
                    viewRenewMotorPolicy?.quoteData?.tenure
                  }${
                    (
                      viewRenewMotorPolicy?.quoteData?.premiumData
                        ?.tenure ||
                      viewRenewMotorPolicy?.quoteData?.tenure
                    )?.search('years') === -1
                      ? ` year${
                          (viewRenewMotorPolicy?.quoteData
                            ?.premiumData?.tenure ||
                            viewRenewMotorPolicy?.quoteData
                              ?.tenure) === '1'
                            ? ''
                            : 's'
                        }`
                      : ''
                  }
                `}
                </Text>
              ) : (
                <Text type="normal" severity="neutral">
                  Not Captured
                </Text>
              ),
          },
          // {
          //   label: 'IDV',
          //   text: viewRenewMotorPolicy?.vehicleTabDetails
          //     ?.insuredDeclaredDetails?.vehicleIDV ? (
          //     <Text type="normal">
          //       {Parse(
          //         viewRenewMotorPolicy?.vehicleTabDetails
          //           ?.insuredDeclaredDetails?.vehicleIDV,
          //         true,
          //         false,
          //         branding,
          //         true,
          //       )}
          //     </Text>
          //   ) : (
          //     <Text type="normal" severity="neutral">
          //       Not Captured
          //     </Text>
          //   ),
          // },
          {
            colSpan: 1,
            text: (
              <div className="flex flex-col items-start justify-start mt-2">
                <span>
                  <Text severity="info" type="label">
                    Annual Premium (inclusive of taxes)
                  </Text>
                </span>
                <span className="flex justify-start space-x-2 items-center">
                  {viewRenewMotorPolicy?.premiumData?.totalPremium ||
                  viewRenewMotorPolicy?.quoteData?.premiumData
                    ?.totalPremium ? (
                    <>
                      <Text type={'larger'} severity={'info'}>
                        {CurrencyFormater(
                          viewRenewMotorPolicy?.premiumData
                            ?.totalPremium ||
                            viewRenewMotorPolicy?.quoteData
                              ?.premiumData?.totalPremium,
                          true,
                          false,
                          branding,
                        )}
                      </Text>
                      <div
                        className="quanta_link mt-1 font-normal"
                        onClick={(_) => setShowViewBreakup(true)}
                      >
                        View Breakup
                      </div>
                    </>
                  ) : (
                    <Text type="normal" severity="neutral">
                      Not Captured
                    </Text>
                  )}
                </span>
              </div>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={
                    !viewRenewMotorPolicy?.isProposalRenewed ||
                    downloadingPDF
                    || viewRenewMotorPolicy?.proposalStatus!=='RC'
                  }
                  onClick={async (_) => {
                    try {
                      const downloadRenewalPDF = mutateQuery({
                        mutation: SEND_RENEWAL_PDF_TW,
                        variables: getRenewalInput(),
                      });
                      setDownloadingPDF(true);
                      const { data: dataBase64String } =
                        await downloadRenewalPDF;
                      const { sendTWRenewalPDF } = dataBase64String;
                      const { base64Pdf: downloadBase64String } =
                        sendTWRenewalPDF;
                      setDownloadingPDF(false);

                      let byteCharacters = atob(
                        downloadBase64String?.toString(),
                      );
                      let byteNumbers = new Array(
                        byteCharacters.length,
                      );
                      for (
                        let i = 0;
                        i < byteCharacters.length;
                        i++
                      ) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                      }
                      let byteArray = new Uint8Array(byteNumbers);
                      let file = new Blob([byteArray], {
                        type: 'application/pdf;base64',
                      });
                      let fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    } catch (error) {
                      setAlerts([
                        {
                          id: Date.now(),
                          content: (
                            <div className="flex flex-col w-full h-full">
                              <Text type="normal">
                                {error.message}
                              </Text>
                            </div>
                          ),
                          type: 'error',
                          timeout: null,
                          disableClose: false,
                        },
                      ]);
                      setDownloadingPDF(false);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >
                  <div className="flex justify-start space-x-8 items-center w-full">
                    <span>
                      {downloadingPDF ? (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          size="lg"
                          className="ml-3"
                          spin={true}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faDownload}
                          size="lg"
                          className="ml-3"
                        />
                      )}
                    </span>
                    <span>
                      {downloadingPDF
                        ? 'Downloading Renewal...'
                        : 'Download Renewal Proposal'}
                    </span>
                  </div>
                </Button>
              </span>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={!viewRenewMotorPolicy?.isProposalRenewed || viewRenewMotorPolicy?.proposalStatus!=='RC'}
                  onClick={(_) => showRenewalEmailModal(true)}
                >
                  <div className="flex justify-start space-x-12 items-center w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        size="lg"
                        className="ml-3"
                      />
                    </span>
                    <span>Email Renewal Proposal</span>
                  </div>
                </Button>
              </span>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={!viewRenewMotorPolicy?.isProposalRenewed || viewRenewMotorPolicy?.proposalStatus!=='RC'}
                  onClick={(_) => showRenewalSMSModal(true)}
                >
                  <div className="flex justify-start space-x-12 items-center w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faSms}
                        size="lg"
                        className="ml-3"
                      />
                    </span>
                    <span>Message Renewal Proposal</span>
                  </div>
                </Button>
              </span>
            ),
          },
        ].filter((d) => d),
      },
    ];

    let renewalProposalSummaryDataMobileView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                Proposal Number {'&'} Status
              </Text>
            ),
            colSpan: 1,
            text:
              viewRenewMotorPolicy?.proposalNumber &&
              viewRenewMotorPolicy?.proposalStatus ? (
                <Text type="normal">
                  {viewRenewMotorPolicy?.proposalNumber} ,{' '}
                  {viewRenewMotorPolicy?.proposalStatus}
                </Text>
              ) : (
                <Text type="normal" severity="neutral-darker">
                  Not Captured
                </Text>
              ),
          },
          {
            colSpan: 1,
            text: (
              <Button
                flat
                type={'button'}
                size="small"
                onClick={async (_) => {
                  if (
                    viewRenewMotorPolicy?.isProposalReadyForRenewal && !viewRenewMotorPolicy?.isProposalRenewing
                  ) {
                    setShowCovers(true);
                    setValuesBeforeEdit(values);
                  }
                }}
                className={`w-auto mt-4 ${
                  !viewRenewMotorPolicy?.isProposalReadyForRenewal ||
                  viewRenewMotorPolicy?.isProposalRenewing
                    ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : ''
                }`}
                iconPre={
                  viewRenewMotorPolicy?.isProposalRenewed ? (
                  <FontAwesomeIcon
                      icon={faEye}
                      size="sm"
                      className="mr-1"
                    />
                  ) : (
                    <FontAwesomeIcon
                    icon={faPen}
                    size="sm"
                    className="mr-1"
                  />
                  )
                }
              >
                {viewRenewMotorPolicy?.isProposalRenewed
                  ? 'View Covers'
                  : `View & Edit Covers`}
              </Button>
            ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex flex-col items-start justify-start mt-2">
                <span>
                  <Text
                    type="label"
                    severity="info"
                    className="whitespace-nowrap"
                  >
                    Annual Premium (inclusive of taxes)
                  </Text>
                </span>
                <span className="flex justify-start space-x-2 items-center">
                  {viewRenewMotorPolicy?.premiumData?.totalPremium ||
                  viewRenewMotorPolicy?.quoteData?.premiumData
                    ?.totalPremium ? (
                    <div className="flex items-center justify-start space-x-2">
                      <span>
                        <Text type={'larger'} severity={'info'}>
                          {CurrencyFormater(
                            viewRenewMotorPolicy?.premiumData
                              ?.totalPremium ||
                              viewRenewMotorPolicy?.quoteData
                                ?.premiumData?.totalPremium,
                            true,
                            false,
                            branding,
                          )}
                        </Text>
                      </span>
                      <span
                        className="pt-0.5"
                        onClick={(_) => setShowViewBreakup(true)}
                      >
                        <Text type="normal" severity="info">
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </Text>
                      </span>
                    </div>
                  ) : (
                    <Text type="normal" severity="neutral">
                      Not Captured
                    </Text>
                  )}
                </span>
              </div>
            ),
          },
          {
            colSpan: 1,
            text: (
              <Button
                flat
                type={'button'}
                size="small"
                onClick={() =>
                  viewRenewMotorPolicy?.isProposalRenewed
                    ? setShowDownloadAndShare(true)
                    : null
                }
                className={`w-auto mt-4 ${
                  !viewRenewMotorPolicy?.isProposalRenewed
                    ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : ''
                }`}
                iconPre={
                  <FontAwesomeIcon
                    icon={faShare}
                    size="sm"
                    className="mr-1"
                  />
                }
              >
                Download & Share
              </Button>
            ),
          },
        ].filter((d) => d),
      },
    ];
    let renewalProposalSummaryDataIPadView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                {'Proposal Number & Status'}
              </Text>
            ),
            colSpan: 1,
            className: '-mt-0.5',
            text: (
              <Text type="normal" className={'flex flex-col'}>
                {viewRenewMotorPolicy?.proposalNumber && (
                  <Text>{viewRenewMotorPolicy?.proposalNumber},</Text>
                )}
                {viewRenewMotorPolicy?.proposalStatus && (
                  <Text>{viewRenewMotorPolicy?.proposalStatus}</Text>
                )}
                {!viewRenewMotorPolicy?.proposalStatus &&
                  !viewRenewMotorPolicy?.proposalNumber && (
                    <Text severity={'neutral-darker'}>
                      Not Captured
                    </Text>
                  )}
              </Text>
            ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex flex-col items-start justify-start mt-2">
                <span>
                  <Text
                    type="label"
                    severity="info"
                    className="whitespace-nowrap"
                  >
                    Annual Premium (inclusive of taxes)
                  </Text>
                </span>
                <span className="flex justify-start space-x-2 items-center">
                  {viewRenewMotorPolicy?.premiumData?.totalPremium ||
                  viewRenewMotorPolicy?.quoteData?.premiumData
                    ?.totalPremium ? (
                    <div className="flex items-center justify-start space-x-2">
                      <span>
                        <Text type={'larger'} severity={'info'}>
                          {CurrencyFormater(
                            viewRenewMotorPolicy?.premiumData
                              ?.totalPremium ||
                              viewRenewMotorPolicy?.quoteData
                                ?.premiumData?.totalPremium,
                            true,
                            false,
                            branding,
                          )}
                        </Text>
                      </span>
                      <span
                        className="pt-0.5"
                        onClick={(_) => setShowViewBreakup(true)}
                      >
                        <Text type="normal" severity="info">
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </Text>
                      </span>
                    </div>
                  ) : (
                    <Text type="normal" severity="neutral">
                      Not Captured
                    </Text>
                  )}
                </span>
              </div>
            ),
          },
          {
            colSpan: 1,
            text: (
              <Button
                flat
                type={'button'}
                size="medium"
                onClick={async (_) => {
                  if (
                    viewRenewMotorPolicy?.isProposalReadyForRenewal && !viewRenewMotorPolicy?.isProposalRenewing
                  ) {
                    setShowCovers(true);
                    setValuesBeforeEdit(values);
                  }
                }}
                className={`w-auto mt-2 ${
                  !viewRenewMotorPolicy?.isProposalReadyForRenewal ||
                  viewRenewMotorPolicy?.isProposalRenewing
                    ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : ''
                }`}
                iconPre={
                  viewRenewMotorPolicy?.isProposalRenewed ? (
                  <FontAwesomeIcon
                      icon={faEye}
                      size="sm"
                      className="mr-1"
                    />
                  ) : (
                    <FontAwesomeIcon
                    icon={faPen}
                    size="sm"
                    className="mr-1"
                  />
                  )
                }
              >
                {viewRenewMotorPolicy?.isProposalRenewed
                  ? 'View Covers'
                  : `View & Edit Covers`}
              </Button>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex justify-end">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className={`w-auto mt-2 ${
                    !viewRenewMotorPolicy?.isProposalRenewed
                      ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                      : ''
                  }`}
                  onClick={(_) =>
                    viewRenewMotorPolicy?.isProposalRenewed
                      ? setShowDownloadAndShare(true)
                      : null
                  }
                >
                  <div className="flex justify-start w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faShare}
                        size="sm"
                        className="mr-1"
                      />
                    </span>
                    <span>{'Download & Share'}</span>
                  </div>
                </Button>
              </span>
            ),
          },
        ].filter((d) => d),
      },
    ];

    return (
      <>
        <QuantaForm>
          <DataGridGroup
            data={
              repeat === repeatForDesktop
                ? renewProposalSummaryDataDesktopView
                : repeat === repeatForMobile
                ? renewalProposalSummaryDataMobileView
                : renewalProposalSummaryDataIPadView
            }
            repeat={repeat}
            textType="label"
            titleType="title"
            titleSeverity="info"
            className="w-full"
            gap={0}
            gapX={16}
            isSeparatorRequired={false}
            gapY={2}
            spaceY={2}
            nullData={() => (
              <Text className="opacity-40">Not Captured</Text>
            )}
          />
          <div>
            <ModalCovers
              {...{
                showCovers,
                setShowCovers,
                forwardedRef: props?.forwardedPremiumFormRef,
                forwardedAlertsRef: props?.forwardedAlertsRef,
                productCode,
                productName,
                productType,
                renewalMode,
                viewRenewMotorPolicy,
                proposalDetails:
                  props?.forwardedRenewFormRef?.current?.values,
                valuesBeforeEdit,
                validate,
              }}
            />
          </div>
          <div>
            <ModalViewBreakupTW
              {...{
                showViewBreakup,
                setShowViewBreakup,
                productName,
                productCode,
                lobCode,
                lobName,
                productType,
                premiumBreakupFor: 'Renewal',
                breakupData: {
                  premiumData: viewRenewMotorPolicy?.premiumData
                    ?.totalPremium
                    ? viewRenewMotorPolicy?.premiumData
                    : viewRenewMotorPolicy?.quoteData?.premiumData,
                  tenure:
                    viewRenewMotorPolicy?.premiumData?.tenure ||
                    viewRenewMotorPolicy?.quoteData?.premiumData
                      ?.tenure ||
                    viewRenewMotorPolicy?.quoteData?.tenure,
                  make: {
                    code:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.make?.code ||
                      viewRenewMotorPolicy?.quoteData?.make?.code,
                    value:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.make?.value ||
                      viewRenewMotorPolicy?.quoteData?.make?.value,
                  },
                  model: {
                    code:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.model?.code ||
                      viewRenewMotorPolicy?.quoteData?.model?.code,
                    value:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.model?.value ||
                      viewRenewMotorPolicy?.quoteData?.model?.value,
                  },
                  variant: {
                    code:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.variant?.code ||
                      viewRenewMotorPolicy?.quoteData?.variant?.code,
                    value:
                      viewRenewMotorPolicy?.vehicleTabDetails
                        ?.vehicleDetails?.variant?.value ||
                      viewRenewMotorPolicy?.quoteData?.variant?.value,
                  },
                  fuelType:
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.vehicleDetails?.fuelType ||
                    viewRenewMotorPolicy?.quoteData?.fuelType,
                  dateOfReg:
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.vehicleDetails?.dateOfRegistration ||
                    viewRenewMotorPolicy?.quoteData?.dateOfReg,
                  rtoAuthorityCode:
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.vehicleDetails?.rtoDetails
                      ?.rtoAuthorityCode ||
                    viewRenewMotorPolicy?.quoteData?.rtoAuthorityCode,
                  rtoLocationDesc:
                    viewRenewMotorPolicy?.vehicleTabDetails
                      ?.vehicleDetails?.rtoDetails?.rtoLocationDesc ||
                    viewRenewMotorPolicy?.quoteData?.rtoLocationDesc,
                  gvw:viewRenewMotorPolicy?.quoteData
                  ?.GVW,
                  cubeCapacity:viewRenewMotorPolicy?.quoteData?.cubeCapacity,
                  NCB:viewRenewMotorPolicy?.quoteData?.NCB
                },
              }}
            />
          </div>
        </QuantaForm>
      </>
    );
  };

  const getCoverInitObj = () => {
    let initObj = {
      addOnCovers: {},
      rawRiskData:
        viewRenewMotorPolicy?.coverData?.rawRiskData?.length > 0
          ? viewRenewMotorPolicy?.coverData?.rawRiskData
          : [],
    };
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach(
      (riskCover) => {
        riskCover?.covers?.forEach((cover) => {
          initObj[`addOnCovers`][`${cover?.name}`] = {
            selected: cover?.selected ? cover?.selected : false,
            riskName: riskCover?.riskType,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            .forEach((attribute) => {
              initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = attribute?.value
                ? attribute?.value
                : attribute?.defaultValue
                ? attribute?.defaultValue
                : '';
            });
        });
      },
    );

    //return initObj;
    return {
      addOnCovers: {
        ...initObj?.addOnCovers,
        ...viewRenewMotorPolicy?.coverData?.addOnCovers,
      },
      rawRiskData:
        viewRenewMotorPolicy?.coverData?.rawRiskData?.length > 0
          ? viewRenewMotorPolicy?.coverData?.rawRiskData
          : [],
    };
  };

  const initialValues = {
    premiumData: {
      idv1: viewRenewMotorPolicy?.premiumData?.idv1,
      idv2: viewRenewMotorPolicy?.premiumData?.idv2,
      idv3: viewRenewMotorPolicy?.premiumData?.idv3,
      tenure:
        viewRenewMotorPolicy?.premiumData?.tenure ||
        viewRenewMotorPolicy?.quoteData?.premiumData?.tenure ||
        viewRenewMotorPolicy?.quoteData?.tenure,
      netODPremium: viewRenewMotorPolicy?.premiumData?.netODPremium,
      netTPPremium: viewRenewMotorPolicy?.premiumData?.netTPPremium,
      loadingDiscount:
        viewRenewMotorPolicy?.premiumData?.loadingDiscount,
      netPremium: viewRenewMotorPolicy?.premiumData?.netPremium,
      gst: viewRenewMotorPolicy?.premiumData?.gst,
      stampDuty: viewRenewMotorPolicy?.premiumData?.stampDuty,
      totalPremium: viewRenewMotorPolicy?.premiumData?.totalPremium,
      loading: viewRenewMotorPolicy?.premiumData?.loading,
      discount: viewRenewMotorPolicy?.premiumData?.discount,
      vehicleAge: viewRenewMotorPolicy?.premiumData?.vehicleAge,
      claimFreeYear: viewRenewMotorPolicy?.premiumData?.claimFreeYear,
      creditScore: viewRenewMotorPolicy?.premiumData?.creditScore,
    },
    ...getCoverInitObj(),
  };

  return (
    <>
      <QuantaFormik
        innerRef={props?.forwardedPremiumFormRef}
        enableReinitialise={true}
        {...{ initialValues, validate }}
      >
        <SummaryForm />
      </QuantaFormik>
      <div>
        <NotificationList
          {...{
            items: [...alerts, ...props?.forwardedAlertsRef?.current],
          }}
        />
      </div>
      <div>
        <ModalSendEmail
          {...{
            SEND_EMAIL_QUERY: SEND_RENEWAL_EMAIL_TW,
            getPayLoad: (email, ccEmailIds) => {
              return {
                ...getRenewalInput(),
                email,
                ccEmailIds,
              };
            },
            initialEmail: getRenewalInput()?.input?.customer?.emailID,
            setShowEmail: showRenewalEmailModal,
            showEmail: displayRenewalEmailModal,
          }}
        />
      </div>
      <div>
        <ModalSendSmsTwoWheeler
          {...{
            SEND_SMS_QUERY: SEND_RENEWAL_SMS_TW,
            getPayLoad: (
              mobile,
              alternateMobileNos,
              whatsappNo,
              modes,
            ) => {
              return {
                ...getRenewalInput(),
                mobile,
                alternateMobileNos,
                whatsappNo,
                modes,
              };
            },
            initialMobile:
              getRenewalInput()?.input?.customer?.mobileNo,
            setShowSms: showRenewalSMSModal,
            showSms: displayRenewalSMSModal,
          }}
        />
      </div>
      <div>
        <DownloadAndShare
          {...{
            showDownloadAndShare,
            setShowDownloadAndShare,
            renewalInput: getRenewalInput(),
          }}
        />
      </div>
    </>
  );
}
